'use client';

import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '@/lib/utils';

const locationTabs = [
  { key: 'levi', label: 'Levi' },
  { key: 'yllas-akaslompolo', label: 'Ylläs (Äkäslompolo)' },
  { key: 'yllas-yllasjarvi', label: 'Ylläs (Ylläsjärvi)' },
] as const;

type LocationKey = (typeof locationTabs)[number]['key'];

export default function DiningTabs({
  children,
}: {
  children: Record<string, React.ReactNode>;
}) {
  const [activeLocation, setActiveLocation] = useState<LocationKey>('levi');

  return (
    <>
      {/* Location Tabs */}
      <div className="flex justify-center mb-12">
        <div
          className="inline-flex rounded-xl p-1 gap-1 bg-slate-100"
        >
          {locationTabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveLocation(tab.key)}
              className={cn(
                'relative px-4 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9B7B3A]',
                activeLocation === tab.key
                  ? 'text-slate-900'
                  : 'text-slate-500 hover:text-slate-700'
              )}
            >
              {activeLocation === tab.key && (
                <motion.span
                  layoutId="activeTab"
                  className="absolute inset-0 rounded-lg bg-white shadow-sm border border-slate-200/60"
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <span className="relative z-10">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Content for each location - all rendered server-side, only visibility toggled */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeLocation}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.25 }}
        >
          {children[activeLocation]}
        </motion.div>
      </AnimatePresence>
    </>
  );
}
